import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input, Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { FETCH_CPSC_PRODUCTS, SAVE_CPSC_PRODUCTS } from "./graphql";

const CPSCProductsBatchUpdateForm = ({ products, onCompleted }) => {
  const [versionId, setVersionId] = useState("");
  const [note, setNote] = useState("");

  const [saveCpscProducts, { loading }] = useMutation(SAVE_CPSC_PRODUCTS, {
    onCompleted: () => {
      Alert("success", "CPSC products updated.");
      onCompleted?.();
    },
    onError: (err) => {
      Alert("error", parseError(err));
    },
    refetchQueries: [{ query: FETCH_CPSC_PRODUCTS }],
    awaitRefetchQueries: true,
  });

  async function handleSubmit() {
    const normalizedVersionId = versionId.trim();
    const normalizedNote = note.trim();

    if (!normalizedVersionId && !normalizedNote) {
      Alert("error", "Please input Version ID or Note.");
      return;
    }

    const mutationProducts = products
      .filter((item) => item.product?.id)
      .map((item) => {
        const input = { productId: item.product.id, note: normalizedNote };
        if (normalizedVersionId) input.versionId = normalizedVersionId;
        return input;
      });

    if (mutationProducts.length === 0) {
      Alert("error", "No valid products selected.");
      return;
    }

    await saveCpscProducts({ variables: { products: mutationProducts } });
  }

  return (
    <div className="space-y-4">
      <div>
        <label className="block">Selected Products: {products.length}</label>
      </div>

      <div className="space-y-3">
        <div className="flex items-center space-x-3">
          <label className="text-sm whitespace-nowrap">New Version ID</label>
          <div className="flex-1">
            <Input
              value={versionId}
              onChange={(e) => setVersionId(e.target.value)}
              placeholder="New Version ID"
            />
          </div>
        </div>
        <Text
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="New Note"
        />
      </div>

      <div className="flex items-center justify-end space-x-2">
        <Button primary onClick={handleSubmit} loading={loading}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default CPSCProductsBatchUpdateForm;
